import React from "react";
import Consultation from "../components/Consultation";

function Contactus() {
  return (
    <div
      style={{
        minHeight: `calc(100vh - 260px)`,
        paddingTop: "100px",
      }}
    >
      <Consultation />
    </div>
  );
}

export default Contactus;
